import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Create,
} from "adminApi/CurrencySettingsApi/CurrencySettings";
import fields from "../json/CurrencyFeilds.json";
import { validateForm } from "utils/validation";
import { PaymentCurrencyRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import AddPaymentCurrencyForm from "./Componates/AddPaymentCurrencyForm";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";

const AddPaymentCurrency = () => {
  const navigate = useNavigate();
  const { formdata } = fields;

  // Initialize form values
  const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

  const { values, errors, handleChange} = useFormChange(initialValues, PaymentCurrencyRules);

  // Form submit hook
  const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
    async (formValues) => {
      const formData = new FormData();
      Object.entries(formValues).forEach(([key, val]) => formData.append(key, val ?? ""));
      return await Create({data:formData});
    },
    (vals) => validateForm(vals, PaymentCurrencyRules),
    () =>{ 
      return navigate(-1)
    },
    "Currency Created successfully"
  );
  return (
    <>
      {(loadingSubmit) && <Spinner isSpinner={true} />}
      <AddPaymentCurrencyForm
        fields={formdata}
        values={values}
        errors={errors}
        handleChange={handleChange}
        handleSubmit={(e) => handleSubmit(e, values)}
        loading={loadingSubmit}
        title="Create Currency"
      />
    </>
  );
};

export default AddPaymentCurrency;
